<template>
			<div class="progress-box">

				<div class="progress-title">
					<h3>Introveted Effect Factor</h3>
					<h2><img src="../assets/diamond.png" alt="star" />
						<div class="text">内向度に影響を与える<br>あなたの特性・能力</div>
					</h2>
				</div><!-- end .box-title -->
				<!--/////////////////////////////////////////////////////////////////-->
				<!--//////////////////////// #sacrifice-mind ////////////////////////-->
				<!--/////////////////////////////////////////////////////////////////-->
				<div id="sacrifice-mind" class="score-wrapper">
					<h2 class="score-title">
						{{	sacrificeMindTitle}}
					</h2><!-- end .percent -->
					<div class="progress-wrapper" >
						<div class="inclination-left">
							<p v-if="sacrificeMindResult.percentageLeft >= 50" v-bind:style="{color:sacrificeMindColor}">
								{{ sacrificeLeftCaption }}<br>
								{{ sacrificeMindResult.percentageLeft + '%'}}
							</p>
							<p v-else>
								{{ sacrificeLeftCaption }}<br>
								{{ sacrificeMindResult.percentageLeft + '%'}}
							</p>
						</div><!-- end .inclination-left -->
							<!--////////＜＜自己犠牲マインドスコア表示＞＞////////-->
							<div class="progress-bg plus" v-if="sacrificeMindResult.percentageLeft >= 50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: sacrificeMindResult.percentageLeft + '%', background: sacrificeMindColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .plus -->
							<div class="progress-bg minus" v-if="sacrificeMindResult.percentageLeft < 50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: sacrificeMindResult.percentageRight + '%', background: sacrificeMindColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .minus -->
						<div class="inclination-right">
								<p v-if="sacrificeMindResult.percentageRight > 50" v-bind:style="{color:sacrificeMindColor}">
								{{ sacrificeRightCaption }}<br>
								{{ sacrificeMindResult.percentageRight + '%'}}
							</p>
							<p v-else>
								{{ sacrificeRightCaption }}<br>
								{{ sacrificeMindResult.percentageRight + '%'}}
							</p>
						</div><!-- end .inclination-right -->
					</div><!-- end .progress-wrapper -->
				</div><!-- end #sacrifice-mind -->
				<!--/////////////////////////////////////////////////////////////////-->
				<!--////////////////////////// #invest-mind /////////////////////////-->
				<!--/////////////////////////////////////////////////////////////////-->
				<div id="invest-mind" class="score-wrapper">
					<h2 class="score-title">
						{{	investMindTitle	}}
					</h2><!-- end .percent -->
					<div class="progress-wrapper" >
						<div class="inclination-left">
							<p v-if="investMindResult.percentageLeft >= 50" v-bind:style="{color:investMindColor}">
								{{ investLeftCaption }}<br>
								<span>{{ investMindResult.percentageLeft + '%'}}</span>
							</p>
							<p v-else>
								{{ investLeftCaption }}<br>
								<span>{{ investMindResult.percentageLeft + '%'}}</span>
							</p>
						</div><!-- end .inclination-left -->
							<!--////////＜＜自己投資マインドスコア表示＞＞////////-->
							<div class="progress-bg plus" v-if="investMindResult.percentageLeft >=50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: investMindResult.percentageLeft + '%', background: investMindColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .plus -->
							<div class="progress-bg minus" v-if="investMindResult.percentageLeft < 50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: investMindResult.percentageRight + '%', background: investMindColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .minus -->
						<div class="inclination-right">
							<p v-if="investMindResult.percentageRight > 50" v-bind:style="{color:investMindColor}">
								{{ investRightCaption }}<br>
								<span>{{ investMindResult.percentageRight + '%'}}</span>
							</p>
							<p v-else>
								{{ investRightCaption }}<br>
								<span>{{ investMindResult.percentageRight + '%'}}</span>
							</p>
						</div><!-- end .inclination-right -->
					</div><!-- end .progress-wrapper -->
				</div><!-- end #invest-mind -->
				<!--/////////////////////////////////////////////////////////////////-->
				<!--///////////////////////// #communication ////////////////////////-->
				<!--/////////////////////////////////////////////////////////////////-->
				<div id="communication" class="score-wrapper">
					<h2 class="score-title">
						{{	communicationTitle	}}
					</h2><!-- end .percent -->
					<div class="progress-wrapper" >
						<div class="inclination-left">
							<p v-if="communicateResult.percentageLeft >= 50" v-bind:style="{color:communicationColor}">
								{{ communicationLeftCaption }}<br>
								<span>{{ communicateResult.percentageLeft + '%'}}</span>
							</p>
							<p v-else>
								{{ communicationLeftCaption }}<br>
								<span>{{ communicateResult.percentageLeft + '%'}}</span>
							</p>
						</div><!-- end .inclination-left -->
							<!--////////＜＜コミュニケーションスコア表示＞＞////////-->
							<div class="progress-bg plus" v-if="communicateResult.percentageLeft >= 50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: communicateResult.percentageLeft + '%', background: communicationColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .plus -->
							<div class="progress-bg minus" v-if="communicateResult.percentageLeft < 50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: communicateResult.percentageRight + '%', background: communicationColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .minus -->
						<div class="inclination-right">
								<p v-if="communicateResult.percentageRight > 50" v-bind:style="{color:communicationColor}">
								{{ communicationRightCaption }}<br>
								<span>{{ communicateResult.percentageRight + '%'}}</span>
							</p>
							<p v-else>
								{{ communicationRightCaption }}<br>
								<span>{{ communicateResult.percentageRight + '%'}}</span>
							</p>
						</div><!-- end .inclination-right -->
					</div><!-- end .progress-wrapper -->
				</div><!-- end #communication -->
				<!--/////////////////////////////////////////////////////////////////-->
				<!--//////////////////////////// #output ////////////////////////////-->
				<!--/////////////////////////////////////////////////////////////////-->
				<div id="output" class="score-wrapper">
					<h2 class="score-title">
						{{	outputTitle	}}
					</h2><!-- end .percent -->
					<div class="progress-wrapper" >
						<div class="inclination-left">
							<p v-if="outputResult.percentageLeft >= 50" v-bind:style="{color:outputColor}">
								{{ outputLeftCaption }}<br>
								<span>{{ outputResult.percentageLeft + '%'}}</span>
							</p>
							<p v-else>
								{{ outputLeftCaption }}<br>
								<span>{{ outputResult.percentageLeft + '%'}}</span>
							</p>
						</div><!-- end .inclination-left -->
							<!--////////＜＜アウトプットスコア表示＞＞////////-->
							<div class="progress-bg plus" v-if="outputResult.percentageLeft >= 50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: outputResult.percentageLeft + '%', background: outputColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .plus -->
							<div class="progress-bg minus" v-if="outputResult.percentageLeft < 50"  v-bind:style="{ width: bgWidth + '%' }">
								<div class="progress-result" v-bind:style="{ width: outputResult.percentageRight + '%', background: outputColor }">
								</div><!-- end .progress-result-->
							</div><!-- end .minus -->
						<div class="inclination-right">
								<p v-if="outputResult.percentageRight > 50" v-bind:style="{color:outputColor}">
								{{ outputRightCaption }}<br>
								<span>{{ outputResult.percentageRight + '%'}}</span>
							</p>
							<p v-else>
								{{ outputRightCaption }}<br>
								<span>{{ outputResult.percentageRight + '%'}}</span>
							</p>
						</div><!-- end .inclination-right -->
					</div><!-- end .progress-wrapper -->
				</div><!-- end #output -->								
			</div><!-- end .progress-box -->				
</template>

<script>


export default {
	name: 'ResultIndexProgress',
	components: {

	},
	
	data: function () {
		return {
			// sacrificeMind
			sacrificeMindTitle:'潜在意識',
			sacrificeLeftCaption:'他人本位',
			sacrificeRightCaption:'自分本位',
			sacrificeMindColor:'#e09d24',
			// investMind
			investMindTitle:'自己投資',
			investLeftCaption:'変革型',
			investRightCaption:'保守型',
			investMindColor:'#e83309',
			// communication
			communicationTitle:'コミュニケーション',
			communicationLeftCaption:'積極型',
			communicationRightCaption:'独立型',
			communicationColor:'#15b527',
			// output
			outputTitle:'アウトプット',
			outputLeftCaption:'創出型',
			outputRightCaption:'操縦型',
			outputColor:'#144d9b',


		}
	},
	props:[
			'bgWidth',
	],
	computed: {
		//sacrificeMind
		sacrificeMindResult:function(){
			return this.$store.getters.sacrificeMindResult
		},
		// investMind
		investMindResult:function(){
			return this.$store.getters.investMindResult
		},
		// communicate
		communicateResult:function(){
			return this.$store.getters.communicateResult
		},
		// output
		outputResult:function(){
			return this.$store.getters.outputResult
		},

	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 .result-index-progreess pc 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/

/*==============================================
.progress-box
===============================================*/
.result-index .wrapper .progress-box{
	width:47.5%;
	border:solid 3px #dcdcdc;
	border-radius:10px;
	padding:40px 0 40px 0;

	.progress-title{
		h2{
			margin: 5px 0 40px 0;
			line-height: 1.25;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 50px;
				height: 50px;
			}
			.text{
				font-size:21px;
				margin:0 0 0 10px;
			}
		}

		h3{
			color: #359799;
			font-size:15px;
			letter-spacing: 1px;
			line-height: 1.25;
		}
	}
}

/*==============================================
.progress-wrapper
===============================================*/
.result-index .wrapper .progress-box .progress-wrapper{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding:10px 15px 10px 15px;

	& .inclination-left,
	& .inclination-right{
		width: 150px;
		font-weight:bold;

	}

	& .inclination-left{
		margin:0 10px 0 0;
	}

	& .inclination-right{
		margin:0 0 0 10px;
	}
}
/*==============================================
.progress-bg
===============================================*/

.result-index .progress-bg{
	background: #e0e0e0;
	border-radius:30px;
	height: 10px;
	width: 100%;
	overflow: hidden;
	text-align: right;
	display: flex;
}

.result-index .progress-bg.plus{
	justify-content: flex-start;
}

.result-index .progress-bg.minus{
	justify-content: flex-end;
}

.result-index .progress-bg .progress-result{
	height: 10px;	
}

/*==============================================
.score-wrapper
===============================================*/
.score-wrapper{
	h2.score-title{
		font-size:18px;
	}
}


/**********************************************************************************
 □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 

◆	Stylesheet: 767pxまで(スマホ)のモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/
@media screen and (max-width: 767px) {


	/*==============================================
	.progress-box
	===============================================*/
	.result-index .wrapper .progress-box{
		width:92%;
		margin:0 auto 0;
		border:solid 3px #dcdcdc;
		border-radius:10px;
		padding:40px 0 40px 0;

		.progress-title{
			h2{
				margin: 5px 0 40px 0;
				line-height: 1.25;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 50px;
					height: 50px;
				}
				.text{
					font-size:5.25vw;
					margin:0 0 0 10px;
				}
			}

			h3{
				color: #359799;
				font-size:15px;
				letter-spacing: 1px;
				line-height: 1.25;
			}
		}
	}
	/*==============================================
	.progress-wrapper
	===============================================*/
	.result-index .wrapper .progress-box .progress-wrapper{

		padding:10px 15px 10px 15px;

		& .inclination-left,
		& .inclination-right{
			font-size:3.95vw;

		}

		& .inclination-left{
			margin:0 10px 0 0;
		}

		& .inclination-right{
			margin:0 0 0 10px;
		}
	}

	/*==============================================
	.score-wrapper
	===============================================*/
	.score-wrapper{
		h2.score-title{
			font-size:4.85vw;
		}
	}


} /* 767px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/


</style>
